import React from 'react';

const NavButtons = (props) => {
  return (
    <div>
      <div class='nav-button-container'>
        <button class='nav-button back-button' onClick={props.handleBack}>
          {props.backText}
        </button>
      </div>
      <div class='nav-button-container'>
        <button class={props.nextClass} onClick={props.handleNext}>
          {props.nextText}
        </button>
      </div>
    </div>
  );
};
export default NavButtons;
